export default ({driver: {address_zip = ''} = {}} = {}) => address_zip;
